import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

import { onMounted, ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'tooth',
  props: {
  disabled:Boolean,
  tooth: {
    type:Array,
    default: () => []
  }
},
  emits: ['onChange'],
  setup(__props, { emit: meit }) {

const props = __props;

const checked= ref<string[]>([]);
const size = ref(0);


const onChange = () => {
  meit('onChange',checked.value)
}

onMounted(()=>{
  console.log(props.tooth);
  checked.value = props.tooth as string[]
  // props.tooth.forEach((item:any,index:number) => {
  //   checked.value[index] = item
  // });
})

return (_ctx: any,_cache: any) => {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_checkbox_group = _resolveComponent("a-checkbox-group")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_checkbox_group, {
      value: checked.value,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((checked).value = $event)),
      style: {"width":"100%"},
      onChange: onChange,
      disabled: __props.disabled
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_space, { size: size.value }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList([8,7,6,5,4,3,2,1], (i) => {
                      return _createVNode(_component_a_checkbox, {
                        value: '1' + i,
                        key: i
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString("1" + i), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["size"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_space, { size: size.value }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_divider, {
                      type: "vertical",
                      style: {"height":"30px","background-color":"#7cb305"}
                    }),
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, (i) => {
                      return _createVNode(_component_a_checkbox, {
                        value: '2' + i,
                        key: i
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString("2" + i), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["size"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_divider, { style: {"height":"1px","background-color":"#7cb305"} }),
        _createVNode(_component_a_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_space, { size: size.value }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList([8,7,6,5,4,3,2,1], (i) => {
                      return _createVNode(_component_a_checkbox, {
                        value: '4' + i,
                        key: i
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString("4" + i), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["size"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_space, { size: size.value }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_divider, {
                      type: "vertical",
                      style: {"height":"30px","background-color":"#7cb305"}
                    }),
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, (i) => {
                      return _createVNode(_component_a_checkbox, {
                        value: '3' + i,
                        key: i
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString("3" + i), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["size"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "disabled"])
  ]))
}
}

})